/**
 * Created by Carsten Hibbeler on 11.02.2016.
 */

import { DefaultFeatureRendererClass } from 'plugin/map-portlet';
import { ClassNames } from '../constants/Constants';

class FliwasOrganization extends DefaultFeatureRendererClass {
    constructor() {
        super(ClassNames.Organization);
    }
}

export default new FliwasOrganization();



// WEBPACK FOOTER //
// ./js/map/FliwasOrganizationFeatureRenderer.js